import React from 'react';
import { Plus } from '@styled-icons/feather';
import styled from 'styled-components';

const AddMenuButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--text-light);
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const AddButton = styled.div`
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: default;
  }
`;

// AddMenuButton renders add menu button on navbar
export function AddMenuButtonEditor({ handler }: { handler: () => void }) {
  return (
    <AddMenuButtonContainer>
      <AddButton
        onClick={handler}
        onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => {
          if (e.key === 'Enter') handler();
        }}
        role="button"
        tabIndex={0}
      >
        <Plus size={15} />
      </AddButton>
    </AddMenuButtonContainer>
  );
}
